/**
 * The version stamp for the four /web files (data.js, app.js,
 * styles.scoped.css, overrides.css).
 *
 * Show day, 2026-10-03, when the site was still on Replit behind Cloudflare:
 * Cloudflare told browsers to keep these files for 4 hours
 * (`Cache-Control: max-age=14400`), and they were loaded by a fixed URL. So a
 * release never reached a phone that had loaded the site in the last 4 hours, and
 * a purge could not reach a copy already on the phone. The build stamps a
 * hash of the four files' bytes (vite.config.ts, VITE_WEB_ASSETS_VERSION) onto the
 * URL, so a release that changes them is a new URL the phone has never cached.
 *
 * Production and staging now run on Railway with no CDN in front, and the API
 * server serves these files itself (api-server src/lib/webStatic.ts). It marks a
 * request immutable for a year only when its ?v= equals the stamp of the bytes it
 * is serving; without the stamp (or with an old one) the file is revalidated.
 *
 * Unset (tests, a dev server without the define) leaves the URL exactly as it was.
 */
export function versioned(src: string, version: string | undefined = import.meta.env.VITE_WEB_ASSETS_VERSION): string {
  return version ? `${src}?v=${encodeURIComponent(version)}` : src;
}
